import { render } from "./ForgetPasswordView.vue?vue&type=template&id=649f6146&scoped=true"
import script from "./ForgetPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordView.vue?vue&type=script&lang=js"

import "./ForgetPasswordView.vue?vue&type=style&index=0&id=649f6146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649f6146"]])

export default __exports__